import type { ServerCredentialInfo } from '@/api/type-server'

type CredentialValidity = Pick<ServerCredentialInfo, 'enabled' | 'expiresAt' | 'validDurationSec'>

export function isCredentialExpired(credential: CredentialValidity, now = Date.now()) {
  const seconds = credential.expiresAt?.seconds
  return seconds > 0 && seconds * 1000 <= now
}

export function getCredentialStatus(credential: CredentialValidity, now = Date.now()) {
  if (isCredentialExpired(credential, now)) return 'expired'
  return credential.enabled ? 'enabled' : 'disabled'
}

export function canBindCredential(credential: CredentialValidity, now = Date.now()) {
  const seconds = credential.expiresAt?.seconds
  return (
    credential.enabled &&
    Number.isFinite(seconds) &&
    (seconds * 1000 > now || (seconds === 0 && credential.validDurationSec === 0))
  )
}
